var $ = require('jquery');

$(document).ready(function() {
    initSlider();
})
function initSlider() {
    $('.slider .slider__items').slick({
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 1
      });
          
}